// extracted by mini-css-extract-plugin
export var container = "_el-1";
export var cornerButtonContainer = "_el-6";
export var disabled = "_el-2";
export var dragActive = "_el-3";
export var fileContainer = "_el-5";
export var hiddenInput = "_el-4";
export var widthContainer = "_el-0";